import { AppLayout } from "@/components/app-layout/AppLayout";
import { Outlet } from "@tanstack/react-router";

export default function UserSettingsLayout() {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
